var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocNavLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_144_67",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3{fill:#03002f}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1595",
    fill: "none",
    d: "M0 0H23V23H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6338",
    transform: "translate(171.99 -.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    fill: "#1c9ad6",
    d: "M-160.526 8.518a4.087 4.087 0 0 0-4.086 4.086 4.086 4.086 0 0 0 4.086 4.086 4.086 4.086 0 0 0 4.086-4.09 4.086 4.086 0 0 0-4.086-4.082z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    d: "M-153.44 6.963a.749.749 0 0 1-.75.75h-1.91a3.357 3.357 0 0 1-3.34-3.36v-1.93a.755.755 0 0 1 .75-.75.749.749 0 0 1 .75.75v1.93a1.859 1.859 0 0 0 1.84 1.86h1.91a.749.749 0 0 1 .75.75z",
    className: "cls-3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    d: "M-153.66 5.363l-3.46-3.47a.749.749 0 0 0-.53-.22h-9.14a.749.749 0 0 0-.75.75v18.57a.743.743 0 0 0 .75.75h12.6a.743.743 0 0 0 .75-.75v-15.1a.749.749 0 0 0-.22-.53zm-1.28 14.88h-11.1V3.173h8.08l.02.02 3 3.01z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    d: "M-161.021 14.224a.476.476 0 0 1-.339-.14l-1.292-1.292a.48.48 0 0 1 0-.678.48.48 0 0 1 .678 0l.953.953 1.944-1.943a.479.479 0 0 1 .677 0 .478.478 0 0 1 0 .678l-2.282 2.282a.476.476 0 0 1-.339.14z",
    className: "cls-3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocNavLogo);
export default __webpack_public_path__ + "static/media/docNavLogo.50f937cfe2b7f70a2948e92dc810365e.svg";
export { ForwardRef as ReactComponent };